import { useTranslation } from 'react-i18next'

import { QA_NAME_CANCEL_BTN, QA_NAME_SAVE_BTN } from '../../../../constants/qa'
import Button from '../../../Button'
import { Buttons } from '../../../Modal'

function DocFlowEditSequenceModalActions(props) {
  const { isLoading } = props

  const { t } = useTranslation()

  return (
    <Buttons>
      <Button.Contained
        isLoading={isLoading}
        qaName={QA_NAME_SAVE_BTN}
        text={t('Modal.SaveBtnKey')}
        onClick={props.onSubmit}
      />
      <Button.Outlined
        qaName={QA_NAME_CANCEL_BTN}
        text={t('Modal.CancelBtnKey')}
        onClick={props.onClose}
      />
    </Buttons>
  )
}

export default DocFlowEditSequenceModalActions
